<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/loud/loud',title:'信息漏斗'},{title:'区域新增'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">
            <div class="h-piece">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-formBox w-formBox">
						<div class="thir-formBox">
							<el-form-item label="区域">
								<el-select
										v-model="formInline.area"
										placeholder="--请选择--"
										clearable
										filterable>
									<el-option
											v-for="item in areaData"
											:key="item.code"
											:label="item.name"
											:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="链群">
								<brselect
										style="width:100%;"
										category="gh_lianqun"
										:v="formInline.chainGroup"
										v-model="formInline.chainGroup"
										clearable
										placeholder="--请选择--">
								</brselect>
							</el-form-item>
						</div>
						<el-form-item class="right-btn">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</el-form-item>
					</div>
				</el-form>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
                            max-height="600"
							border
                            :summary-method="getSummaries"
							@cell-click="changecell"
                            show-summary
                            style="width: 100%">
                        <el-table-column
                        type="selection"
                        width="50"
                        fixed
                        >
                        </el-table-column>
                        <el-table-column
                            type="index"
                            width="40"
                            label="#"
                        	fixed
                            >
                         </el-table-column>
                        <el-table-column
                                prop="code"
								width="100"
								:show-overflow-tooltip="true"
                                label="区域">
                            <template slot-scope="scope">
                                <dictname category="YLRegion" :v="scope.row.code"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="level1"
                                :label="levelname1"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level1}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level2"
                                :label="levelname2"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level2}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level3"
                                :label="levelname3"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level3}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level4"
                                :label="levelname4"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level4}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level5"
                                :label="levelname5"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level5}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level6"
                                :label="levelname6"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level6}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level7"
                                :label="levelname7"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level7}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level8"
                                :label="levelname8"
								:show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level8}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="level9"
                                :label="levelname9"
                                :show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.level9}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="total"
								width="100"
                                label="合计(万元)">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.total}}
									</div>
								</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                </div>
            </div>
        </div>
		<el-dialog
		        title=""
		        :visible.sync="dialogVisible"
		        :fullscreen="false"
		        width="50%"
		        :modal="true"
		        :before-close="handleClose">
		    <div class="tanBox">
		        <el-table
		                :data="tableDatas"
		                @selection-change="handleSelectionChange"
		        		max-height="400"
						border
		                style="width: 100%">
		            <el-table-column
		                    fixed="left"
		                    type="selection"
		                    width="45">
		            </el-table-column>
		            <el-table-column
		                    type="index"
		                    width="40"
		                    fixed="left"
		                    label="#">
		            </el-table-column>
		            <el-table-column
		                    prop="projectName"
		                    label="项目名称"
		                    width="180"
		                    fixed="left"
		                    :show-overflow-tooltip="true">
		        			<template slot-scope="scope">
		        				<div style="text-align: left;">{{scope.row.projectName}}</div>
		        			</template>
		            </el-table-column>
		            <el-table-column
		                    prop="statusR"
		                    label="节点"
		                    width="100"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="xinxi_jiedian"  :v="scope.row.statusR"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="ldate"
		                    label="最后更新时间"
		                    width="120"
		                    :show-overflow-tooltip="true">
		            </el-table-column>
		            <el-table-column
		                    prop="expectConvertDate"
		                    label="报单日期"
		                    width="100"
		                    value-format="yyyy-MM-dd"
		                    :show-overflow-tooltip="true">
		            </el-table-column>
		            <el-table-column
		                    prop="expConvDate"
		                    label="预计成单日期"
		                    width="120"
		                    value-format="yyyy-MM-dd"
		                    :show-overflow-tooltip="true">
		            </el-table-column>
		            <el-table-column
		                    prop="area"
		                    label="区域"
							width="80"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="YLRegion"  :v="scope.row.area"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="chainGroup"
		                    label="链群"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="gh_lianqun"  :v="scope.row.chainGroup"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="customerChannel"
		                    label="渠道"
		                    width="80"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="loud_region"  :v="scope.row.customerChannel"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="partner"
		                    label="合伙人名称"
		                    width="180"
		                    :show-overflow-tooltip="true">
		        			<template slot-scope="scope">
		        				<div style="text-align: left;">{{scope.row.partner}}</div>
		        			</template>
		            </el-table-column>
		            <el-table-column label="用户信息">
		                <el-table-column
		                        prop="customerName"
		                        label="用户单位"
		                        width="180"
		                        :show-overflow-tooltip="true">
		        				<template slot-scope="scope">
		        					<div style="text-align: left;">{{scope.row.customerName}}</div>
		        				</template>
		                </el-table-column>
		                <el-table-column
		                        prop="deptName"
		                        label="部门/科室"
		                        width="100"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="chargePerson"
		                        label="负责人"
		                        width="80"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="phone"
		                        label="电话"
		                        width="120"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		            </el-table-column>
		            <el-table-column label="产品信息">
		                <el-table-column
		                        prop="productModel"
		                        label="产品型号"
		                        width="150"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="num"
		                        label="数量"
		                        width="60"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="price"
		                        label="价格(万元)"
		                        width="100"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="totalValue"
		                        label="合计(万元)"
		                        width="100"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		            </el-table-column>
		            <el-table-column label="中/丢标分析">
		                <el-table-column
		                        prop="dbBrand"
		                        label="中标品牌"
		                        width="100"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="dbTotalValue"
		                        label="中/丢标总额"
		                        width="120"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		                <el-table-column
		                        prop="dbReason"
		                        label="丢标原因"
		                        width="150"
		                        :show-overflow-tooltip="true">
		                </el-table-column>
		            </el-table-column>
		            <el-table-column
		                    prop="merchandier"
		                    label="跟单商类别"
		                    width="110"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="gendanshang"  :v="scope.row.merchandier"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="supplement"
		                    label="是否挂网补录"
		                    width="120"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="shifou_keyong"  :v="scope.row.supplement"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="whetherContactor"
		                    label="是否城市网"
		                    width="110"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="chengshi_wang"  :v="scope.row.whetherContactor"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="messageType"
		                    label="信息类别"
		                    width="90"
		                    :show-overflow-tooltip="true">
		                <template slot-scope="scope">
		                    <dictname category="message_type"  :v="scope.row.messageType"/>
		                </template>
		            </el-table-column>
		            <el-table-column
		                    prop="remark"
		                    label="备注"
		                    width="180"
		                    :show-overflow-tooltip="true">
		        			<template slot-scope="scope">
		        				<div style="text-align: left;">{{scope.row.remark}}</div>
		        			</template>
		            </el-table-column>
		        </el-table>
		    </div>
            <div style="display:flex;justify-content: space-between;align-items:center;margin-top:20px">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportMsgExcel">批量导出
                </el-button>
                <paginationmin :page="formInline" @query="handlefanye"/>
            </div>
		</el-dialog>
    </div>
</template>
<script>
    import big from 'big.js';
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile';

    export default {
        data() {
            return {
				tableDatas:[],
				dialogVisible:false,
                objectlists: [],
                areaData: [],
                multipleSelection: [],
                levelname1: '',
                levelname2: '',
                levelname3: '',
                levelname4: '',
                levelname5: '',
                levelname6: '',
                levelname7: '',
                levelname8: '',
                levelname9: '',
                tableData: [],
                formInline: {
                    area: '',
                    chainGroup: '',
                    hang: '',
                    lie: '',
                    del: 1,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
            }
        },
        mounted() {

        },
        created() {
            var data = this.$store.getters.dictlist("YLRegion");
            for (var i = 0; i < data.length; i++) {
                if (data[i].code != '000' && data[i].code != '200' && data[i].code != '270' && data[i].code != '280' && data[i].code != '300' && data[i].code != '310' && data[i].code != '330' && data[i].code != '340') {
                    this.areaData.push(data[i]);
                }
            }
            this.showType();
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            exportMsgExcel() {
                var idlist=[];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/viewArea/downloadExcel",idlist,"post",'data');
            },
            //明细导出
            exportExcel() {
                var ids=[];
                for (var j = 0; j < this.tableData.length; j++) {
                    ids.push(this.tableData[j]);
                }
                updownfile.down("/api/swyl/v1/demo/viewArea/downloadAreaAddExcel",ids,"post",'data');
            },
			changecell(row, column, cell, event){
                this.formInline.hang = row.code;
                this.formInline.lie = column.label;
                ss.loud.selectAreaGroupPage(this.formInline).then(rd => {
                    this.tableDatas = rd.records;
                    this.formInline.total = rd.total;
                    this.dialogVisible = true;
                })
			},
            handlefanye() {
                ss.loud.selectAreaGroupPage(this.formInline).then(rd => {
                    this.tableDatas = rd.records;
                    this.formInline.total = rd.total;
                })
            },
			//关闭弹出框
			handleClose(v) {
			    v()
			},
            handleFilter() {
                ss.loud.showAdd(this.formInline).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        // this.setItemDate(this.tableData[i])
                        for (var j = 0; j < this.objectlists.length; j++) {
                            var ol = this.objectlists[j];
                            this.tableData[i]['level' + (j + 1)] = this.tableData[i].map[ol] || null;
                        }
                    }
                    this.sumNum();
                })
            },
            resetData() {
                this.formInline.area = '';
                this.formInline.chainGroup = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1,
                this.query();
            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return new big(prev).plus(curr).toFixed(2);
                            } else {
                                return prev;
                            }
                        }, 0);
						
						sums[2] = '';
                    } else {
                        sums[1] = '';
                    }
                });

                return sums;
            },
            query() {
                ss.loud.showAdd(this.formInline).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        // this.setItemDate(this.tableData[i])
                        for (var j = 0; j < this.objectlists.length; j++) {
                            var ol = this.objectlists[j];
                            this.tableData[i]['level' + (j + 1)] = this.tableData[i].map[ol] || null;
                        }
                    }
                    this.sumNum();
                })
            },
            showType() {
                ss.loud.showType().then(rd => {
                    rd.forEach((item, index) => {
                        this['levelname' + (index + 1)] = item;
                        this.objectlists.push(item);
                    })
                })
                this.query();
            },
            setItemDate(obj) {
                for (var j = 0; j < this.objectlists.length; j++) {
                    var ol = this.objectlists[j];
                    obj['level' + (j + 1)] = obj.map[ol] || null;
                }
            },
            sumNum(){
                this.tableData.forEach((item, index) => {
                    let tot = 0.0;
                    for (var i=0 ; i<9 ; i++) {
                        tot = new big(tot).plus(item['level' + (i + 1)] || 0);
                    }
                    item.total = tot.toFixed(2);
                })
            }
        }
    }
</script>
<style>
    .tanBox .el-table thead.is-group th{
        background:#57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
</style>